import styled from 'styled-components';

export const StyledInput = styled.input<{ $error?: string | null; $borderColor: string; $errorColor: string }>`
  height: 40px;
  width: 100%;
  border-radius: 0.375rem;
  border: 1px solid ${({ $error, $errorColor, $borderColor }) => ($error ? $errorColor : $borderColor)};
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  outline: none;

  &:focus {
    border-color: ${({ $borderColor }) => $borderColor};
  }
`;

export const StyledLabel = styled.label<{ $hasError: boolean; $color: string; $errorColor: string }>`
  font-size: 0.875rem;
  color: ${({ $hasError, $color, $errorColor }) => ($hasError ? $errorColor : $color)};
`;